module.exports = __webpack_public_path__ + "static/media/Simran.160b2456.jpg";